var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562 190.5L541 218L557.5 329L590.5 334L598 384H616V390.5H630.5L636.5 379L652.5 363.5L670.5 349L698 334L721 325L743.5 316.5L769.5 310H784L788 296.5H817.5V264H792.5L784 131H769.5L765 141H754V125H708L704.5 169L691.5 157L681 161.5V172L667.5 175V161.5L623.5 175L636.5 288L623.5 293.5L607.5 184.5L578 179L570.5 187L573 194.5L566.5 198.5L562 190.5Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReve);
export default __webpack_public_path__ + "static/media/reve.38f0a43fc2ad7578a629672e7914af80.svg";
export { ForwardRef as ReactComponent };